import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  inputShedule: {
    margin: 0,
    padding: 0,
    width: '100%',
    cursor: 'pointer',
  },
  inputSheduleLoading: {
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    margin: 0,
    padding: 0,
    width: '100%',
    cursor: 'wait',
  },
}));
